import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBatteryEmpty"><Path fillRule="evenodd" clipRule="evenodd" d="M1 7.75C1 6.23122 2.23122 5 3.75 5H17.25C18.7688 5 20 6.23122 20 7.75V8H21.25C22.2165 8 23 8.7835 23 9.75V14.25C23 15.2165 22.2165 16 21.25 16H20V16.25C20 17.7688 18.7688 19 17.25 19H3.75C2.23122 19 1 17.7688 1 16.25V7.75ZM20 14.5H21.25C21.3881 14.5 21.5 14.3881 21.5 14.25V9.75C21.5 9.61193 21.3881 9.5 21.25 9.5H20V14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBatteryEmpty;
